import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

//Redux
/*import { connect } from '../../stores'*/

const CommonRoute = ({
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      return <Component {...props} />
    }}
  />
);

CommonRoute.propTypes = {
  component: PropTypes.any,
};

CommonRoute.defaultProps = {
};

export default CommonRoute
